import { render, staticRenderFns } from "./EcommerceSetting.vue?vue&type=template&id=4d03bc84&scoped=true"
import script from "./EcommerceSetting.vue?vue&type=script&lang=js"
export * from "./EcommerceSetting.vue?vue&type=script&lang=js"
import style0 from "./EcommerceSetting.vue?vue&type=style&index=0&id=4d03bc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d03bc84",
  null
  
)

export default component.exports